module.exports = __webpack_public_path__ + "static/media/NEWS_simp0136_pressRelease.cf7be8d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/NEWS_simp0136_pressRelease.jpg
// module id = 170
// module chunks = 0